import React from "react";

import { faPlus, faTrash } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconButton, Grid } from "@material-ui/core";

import { withArrayNamespace } from "components/Form/FormikControls";

import { ValueSource } from "constants/ruleBooks";

import { useFieldState } from "hooks";

import { Check } from "./Check";

export function getCheckTemplate() {
  return {
    comparator: "",
    field: {
      source: ValueSource.FIELD,
      value: "",
    },
    values: [""],
  };
}

export function CheckGroup(props) {
  const {
    criteriaIndex,
    criteriaOptions,
    namespace: ns,
    onRemoveLastCondition,
    checkFieldPath,
    parentInputPath = null,
    showPrerequisiteRuleSource = null,
    readOnly,
  } = props;
  const [checks, setValue] = useFieldState(ns);

  function onClickAddCondition() {
    setValue([
      ...checks,
      // Add the union of all the fields for a new condition so that the preselected `select` `option` show "Select X from the dropdown"
      getCheckTemplate(),
    ]);
  }

  function onRemoveCondition(index) {
    const newValue = checks.slice();
    newValue.splice(index, 1);
    setValue(newValue);
    if (newValue.length === 0) {
      onRemoveLastCondition();
    }
  }

  return (
    <>
      {checks.map((check, i) => (
        <Grid container item spacing={1} xs={12} key={i}>
          <Check
            criteriaIndex={criteriaIndex}
            criteriaOptions={criteriaOptions}
            namespace={withArrayNamespace(ns, i)}
            checkFieldPath={checkFieldPath}
            parentInputPath={parentInputPath}
            showPrerequisiteRuleSource={showPrerequisiteRuleSource}
            readOnly={readOnly}
          />
          {!readOnly && (
            <Grid item>
              <IconButton
                aria-label="delete"
                onClick={() => onRemoveCondition(i)}
              >
                <FontAwesomeIcon icon={faTrash} size="xs" />
              </IconButton>
            </Grid>
          )}
        </Grid>
      ))}
      {!readOnly && (
        <IconButton
          aria-label="Add Condition"
          onClick={onClickAddCondition}
          size="small"
        >
          <FontAwesomeIcon icon={faPlus} size="xs" />
          &nbsp;Condition
        </IconButton>
      )}
    </>
  );
}
